import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarKelolaFAQsAdmin from "../../components/TopBarKelolaFAQsAdmin";
import KelolaFAQs from "../../components/KelolaFAQs";
import "../../CSS/KelolaFAQs.css";

function HalamanKelolaFAQsAdmin() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarKelolaFAQsAdmin />

        {/* Konten utama */}
        <div className="kelola-faqs">
          <KelolaFAQs />
        </div>
      </div>
    </div>
  );
}

export default HalamanKelolaFAQsAdmin;